import { useEffect } from "react";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { AppConstants } from "../../constants";
import { loadMetaPixel } from "utils/metaPixel";
import { Drawer, Button, FocusTrap, Group, Box } from "@mantine/core";
import BasicButton from "components/button/basic";
import SectionLabel from "components/section/label";
import SectionText from "components/section/text";

const { META_PIXEL_ID } = AppConstants;

const Banner = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem("pixelConsent");

    if (!consent) {
      open();
    } else if (consent === "accepted") {
      const load = () => loadMetaPixel(META_PIXEL_ID);

      if ("requestIdleCallback" in window) {
        requestIdleCallback(load);
      } else {
        setTimeout(load, 2000);
      }
    }
  }, [open]);

  
  const handleAccept = () => {
    localStorage.setItem("pixelConsent", "accepted");

    const load = () => {
      loadMetaPixel(META_PIXEL_ID);
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(load);
    } else {
      setTimeout(load, 0);
    }

    close();
  };

  const handleReject = () => {
    localStorage.setItem("pixelConsent", "declined");
    close();
  };

  return (
    <Drawer.Root
      position="bottom"
      opened={opened}
      onClose={() => {}}
      closeOnEscape={false}
      closeOnClickOutside={false}
      zIndex={9999999}
    >
      <Drawer.Overlay />
      <Drawer.Content
        h={"auto"}
        p={{ base: 16, sm: 50 }}
        aria-labelledby={"Meta Pixel consent nanner"}
        style={{ borderRadius: "40px 40px 0 0" }}
      >
        <FocusTrap.InitialFocus />
        <Drawer.Body>
          <Box>
            <SectionLabel
              weight={600}
              label={t("pixel-banner.title")}
              mb={20}
            />
            <SectionText variant="dark" text={t("pixel-banner.description")} />
            <Group justify="flex-end" gap={20} mt={40}>
              <Button
                variant="transparent"
                color="#333343"
                onClick={handleReject}
              >
                {t("pixel-banner.reject")}
              </Button>
              <BasicButton onClick={handleAccept}>
                {t("pixel-banner.consent")}
              </BasicButton>
            </Group>
          </Box>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default Banner;
